import React from 'react'
import InfoButton from './InfoButton'
import { handlingFeeExplanation } from '@/utils/deliveryPolicyText'

type HandlingFeeInfoProps = {
    label: string
    /** The fee as shown on its line, e.g. "$12.00". */
    formattedAmount: string
}

/** The ⓘ beside the Import & handling fee line, explaining what the fee is for. */
const HandlingFeeInfo: React.FC<HandlingFeeInfoProps> = ({ label, formattedAmount }) => (
    <InfoButton
        title={label}
        text={handlingFeeExplanation(formattedAmount)}
        ariaLabel={`What is the ${label}?`}
        className="w-4 h-4"
    />
)

export default HandlingFeeInfo
